<div class="filters-container">
  <!-- 下拉選單篩選公司 -->
  <!-- <div class="filter-group">
    <label for="companyFilter">篩選公司:</label>
   <select [(ngModel)]="selectedCompany" (change)="onCompanyChange()">
  <option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</option>
</select>
  </div> -->

  <!-- 下拉選單篩選 topic -->
  <div class="filter-group">
    <label for="topicFilter">篩選主題 (Topic):</label>
    <select id="topicFilter" [(ngModel)]="selectedTopic" (change)="loadRegulations()">
      <option *ngFor="let topic of uniqueTopics" [value]="topic">{{ topic }}</option>
    </select>
  </div>

  <!-- 顯示當前主題的標籤 -->
  <!-- <div class="filter-group" *ngIf="selectedTopic && topicTags.length > 0">
    <label>標籤清單:</label>
    <div class="topic-tags-container">
      <span class="topic-tag" *ngFor="let tag of topicTags">{{ tag }}</span>
    </div>
  </div> -->

  <!-- 批次导入法规下拉菜单按钮 -->
  <div class="dropdown-wrapper">
    <button class="action-btn import-btn" (click)="toggleImportDropdown($event)">
      <i class="fa-solid fa-file-import"></i> 批次導入法規 <i class="fa-solid fa-caret-down"></i>
    </button>
    <div class="dropdown-menu" [class.show]="showImportDropdown">
      <button class="dropdown-item" (click)="openExcelImportDialog()">
        <i class="fa-solid fa-file-excel"></i> 從Excel匯入
      </button>
      <button class="dropdown-item" (click)="addNewRegulationBySample()">
        <i class="fa-solid fa-database"></i> 從ISO範本庫新增
      </button>
    </div>
  </div>

  <!-- 新增：編輯清單下拉菜單按钮 -->
  <div class="dropdown-wrapper">
    <button class="action-btn edit-btn" (click)="toggleEditListDropdown($event)">
      <i class="fa-solid fa-edit"></i> 編輯清單 <i class="fa-solid fa-caret-down"></i>
    </button>
    <div class="dropdown-menu" [class.show]="showEditListDropdown">
      <button class="dropdown-item" (click)="openEditTopicDialog()">
        <i class="fa-solid fa-pen"></i> 編輯主題名稱
      </button>
      <button class="dropdown-item" (click)="openDeleteTopicDialog()">
        <i class="fa-solid fa-trash"></i> 刪除主題
      </button>
    </div>
  </div>
</div>

<div id="summary" *ngIf="!isLoadingRegulations">
  <p class="summary-info">
    <span class="summary-label">分類總數：</span>
    <span class="summary-value">{{ uniqueTypesWithCounts.length || 0 }}</span>
    <span class="summary-separator">、</span>
    <span class="summary-label">法規總數：</span>
    <span class="summary-value">{{ getTotalLawsCount() | number }}</span>
    <span class="summary-separator">、</span>
    <span class="summary-label">法條總數：</span>
    <span class="summary-value">{{ getTotalArticlesCount() | number }}</span>
  </p>
  <div class="summary-actions">
    <button *ngIf="lawsNeedingContentCount > 0" class="action-btn batch-load-btn" (click)="batchLoadLawContents()">
      <i class="fa-solid fa-cloud-download-alt"></i> 批次載入 {{ lawsNeedingContentCount }} 筆法規
    </button>
<button class="action-btn check-changes-btn" (click)="checkLawsChanges()"
  [title]="lastscandate ? '上次掃描時間：' + lastscandate : '尚未進行過掃描'">
  <ng-container *ngIf="!isCheckingChanges">
    <i class="fa-solid fa-sync-alt"></i> 檢查法規異動狀況
  </ng-container>
  <ng-container *ngIf="isCheckingChanges">
    <i class="fa-solid fa-stop"></i> 點此停止法規異動掃描
  </ng-container>
</button>
  </div>
</div>
<div id="summary-loading" *ngIf="isLoadingRegulations" style="text-align:center; margin: 24px 0;">
  <i class="fa-solid fa-spinner fa-spin" style="font-size: 1.5em;"></i>
  <span style="margin-left: 8px;">資料載入中...</span>
</div>

<div class="advanced-filters-container">

  <div class="advanced-filters" *ngIf="showAdvancedFilters">
    <div class="filter-row">
      <!-- 修改日期區間篩選，將開始和結束日期放在同一行 -->
      <div class="filter-group date-range-filter">
        <label>修訂日期區間:</label>
        <div class="date-inputs-inline">
          <div class="date-input-group">
            <span>從</span>
            <input type="date" [(ngModel)]="dateRangeFilter.start">
          </div>
          <div class="date-input-group">
            <span>到</span>
            <input type="date" [(ngModel)]="dateRangeFilter.end">
          </div>
        </div>
      </div>

      <!-- 將原有的相關性複選框改為多選下拉選單 -->
      <div class="filter-group relevance-filter">
        <label>相關性:</label>
        <div class="multiselect-dropdown" tabindex="0" (blur)="onRelevanceDropdownBlur()">
          <div class="multiselect-selected" (click)="toggleRelevanceDropdown($event)">
            <span *ngIf="getSelectedRelevanceCount() === 0">選擇相關性...</span>
            <span *ngIf="getSelectedRelevanceCount() > 0">
              已選擇 {{ getSelectedRelevanceCount() }} 項
            </span>
            <i class="fa-solid fa-chevron-down"></i>
          </div>
          <div class="multiselect-options" [class.show]="showRelevanceDropdown">
            <div class="multiselect-option">
              <label class="checkbox-label">
                <input type="checkbox" [(ngModel)]="relevanceFilter.related">
                <span class="relevance-icon related">O</span>
                相關
              </label>
            </div>
            <div class="multiselect-option">
              <label class="checkbox-label">
                <input type="checkbox" [(ngModel)]="relevanceFilter.unrelated">
                <span class="relevance-icon unrelated">X</span>
                無關
              </label>
            </div>
            <div class="multiselect-option">
              <label class="checkbox-label">
                <input type="checkbox" [(ngModel)]="relevanceFilter.reference">
                <span class="relevance-icon reference">-</span>
                參考
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- 將原有的標籤選擇改為多選下拉選單，增加寬度 -->
      <div class="filter-group department-filter expanded-width">
        <label>標籤:</label>
        <div class="multiselect-dropdown" tabindex="0" (blur)="onDepartmentDropdownBlur()">
          <div class="multiselect-selected" (click)="toggleDepartmentDropdown($event)">
            <span *ngIf="selectedDepartmentFilters.length === 0">選擇標籤...</span>
            <span *ngIf="selectedDepartmentFilters.length > 0">
              已選擇 {{ selectedDepartmentFilters.length }} 個標籤
            </span>
            <i class="fa-solid fa-chevron-down"></i>
          </div>
          <div class="multiselect-options" [class.show]="showDepartmentDropdown">
            <div class="search-box">
              <input type="text" [(ngModel)]="departmentSearchText" placeholder="搜尋標籤..." (input)="filterDepartments()" (click)="$event.stopPropagation()">
            </div>
            <div class="multiselect-option select-all-option">
              <label class="checkbox-label" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="isAllDepartmentsSelected()" 
                       (change)="toggleAllDepartmentSelection()">
                <strong>全選</strong>
              </label>
            </div>
            <div class="multiselect-divider"></div>
            <div class="multiselect-option" *ngFor="let dept of filteredDepartments">
              <label class="checkbox-label" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="isDepartmentSelected(dept)"
                  (change)="toggleDepartmentSelection(dept)">
                {{ dept }}
              </label>
            </div>
          </div>
        </div>

      </div>

      <!-- 篩選操作按鈕區保持不變，確保套用按鈕功能正常 -->
      <div class="filter-actions">
        <button class="action-btn apply-filter-btn" (click)="applyFilters()">
          <i class="fa-solid fa-filter"></i> 套用篩選
        </button>
        <button class="action-btn reset-filter-btn" (click)="resetFilters()">
          <i class="fa-solid fa-undo"></i> 重置篩選
        </button>
      </div>


    </div>

  </div>

  <!-- 增加變更狀態提示和操作按鈕 -->
  <div class="modifications-bar" *ngIf="hasModifications">
    <div class="modifications-info">
      <i class="fa-solid fa-pen-to-square"></i>
      您已修改 <span class="modified-count">{{ modifiedLaws.size }}</span> 筆資料，尚未儲存
    </div>
    <div class="modifications-actions">
      <button class="action-btn save-all-btn" (click)="saveAllModifications()" title="儲存所有變更">
        <i class="fa-solid fa-save"></i> 儲存變更
      </button>
      <button class="action-btn cancel-all-btn" (click)="cancelAllModifications()" title="取消所有變更">
        <i class="fa-solid fa-undo"></i> 復原變更
      </button>
    </div>
  </div>


  <!-- 修改後的布局，讓 Tab 和法規列表左右排列 -->
  <div class="content-split-view">
    <!-- 左側：分類標籤 Tab -->
    <div class="left-panel" [class.collapsed]="isPanelCollapsed" *ngIf="!isLoadingRegulations">
      <div class="panel-header">
        <h3>法規分類</h3>
        <button class="toggle-panel-btn" (click)="togglePanel()">
          <i class="fa" [ngClass]="isPanelCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
        </button>
      </div>

      <div class="panel-content" [class.hidden]="isPanelCollapsed">
        <ul class="vertical-tabs">
          <!-- ALL 選項 -->
          <li [class.active]="selectedType === 'ALL'" (click)="selectType('ALL')">
            ALL <span class="law-count">({{ getTotalLawsCount() }})</span>
          </li>
          <!-- 其他類型選項 -->
          <li *ngFor="let type of uniqueTypesWithCounts" [class.active]="type.type === selectedType"
            (click)="selectType(type.type)">
            {{ type.type }} <span class="law-count">({{ type.count }})</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 右側：法規列表 -->
    <div class="right-panel" [class.expanded]="isPanelCollapsed" *ngIf="!isLoadingRegulations">
      <div class="right-panel-header">
        <h3 *ngIf="selectedType">{{ selectedType === 'ALL' ? '所有法規' : selectedType }}</h3>


        <div class="action-buttons">

          <button class="action-btn toggle-filters-btn" (click)="toggleAdvancedFilters()">
            <i class="fa-solid" [ngClass]="showAdvancedFilters ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            {{ showAdvancedFilters ? '收起進階篩選' : '顯示進階篩選' }}
          </button>


          <button class="action-btn delete-btn" [disabled]="!hasSelectedItems()" (click)="confirmDeleteSelectedLaws()">
            <i class="fa-solid fa-trash"></i> 刪除法規
          </button>

          <!-- 批次設定下拉選單 -->
          <div class="dropdown-wrapper">
            <button class="action-btn batch-btn" [disabled]="!hasSelectedItems()" (click)="toggleBatchDropdown($event)">
              <i class="fa-solid fa-cog"></i> 批次設定 <i class="fa-solid fa-caret-down"></i>
            </button>
            <div class="dropdown-menu" [class.show]="showBatchDropdown">
              <button class="dropdown-item" (click)="batchSetCode()">設定法規代碼</button>
              <button class="dropdown-item" (click)="batchSetRelevance()">設定相關性</button>
              <button class="dropdown-item" (click)="batchSetDepartments()">設定標籤</button>
            </div>
          </div>



          <!-- 指派查核任務按鈕 -->
          <button class="action-btn assign-task-btn" [disabled]="!hasSelectedItems()"
            (click)="addNewRegulationFromList()">
            <i class="fa-solid fa-clipboard-check"></i> 指派查核任務
          </button>


          <!-- 單筆新增法規按鈕 -->
          <button class="action-btn add-btn" (click)="addInlineRegulation()">
            <i class="fa-solid fa-pen"></i> 單筆新增法規
          </button>
        </div>
      </div>

      <!-- 使用表格顯示法規 -->
      <div class="table-container">
        <table class="regulation-table">
          <thead>
            <tr>
              <th class="col-checkbox"><input type="checkbox" (change)="toggleAllCheckboxes($event)"></th>
              <th class="col-type sortable-header" (click)="onSortClick('type')">
                分類
                <span [class]="getSortIndicatorClass('type')">
                  <i class="fa-solid fa-sort" *ngIf="!isCurrentSortField('type')"></i>
                  <i class="fa-solid fa-sort-up" *ngIf="isCurrentSortField('type') && sortDirection === 'asc'"></i>
                  <i class="fa-solid fa-sort-down" *ngIf="isCurrentSortField('type') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th class="col-level sortable-header" style="width: 80px" (click)="onSortClick('law_hierarchy')">
                層級
                <span [class]="getSortIndicatorClass('law_hierarchy')">
                  <i class="fa-solid fa-sort" *ngIf="!isCurrentSortField('law_hierarchy')"></i>
                  <i class="fa-solid fa-sort-up" *ngIf="isCurrentSortField('law_hierarchy') && sortDirection === 'asc'"></i>
                  <i class="fa-solid fa-sort-down" *ngIf="isCurrentSortField('law_hierarchy') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th class="col-name sortable-header" (click)="onSortClick('law_name')">
                法規名稱
                <span [class]="getSortIndicatorClass('law_name')">
                  <i class="fa-solid fa-sort" *ngIf="!isCurrentSortField('law_name')"></i>
                  <i class="fa-solid fa-sort-up" *ngIf="isCurrentSortField('law_name') && sortDirection === 'asc'"></i>
                  <i class="fa-solid fa-sort-down" *ngIf="isCurrentSortField('law_name') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th>來源網址</th>
              <th style="width: 60px;" class="col-article">法條</th>
              <th style="width: 120px;" class="col-code">法規代碼</th>
              <th style="width: 120px;" class="col-relevance sortable-header" (click)="onSortClick('relevance')">
                相關性
                <span [class]="getSortIndicatorClass('relevance')">
                  <i class="fa-solid fa-sort" *ngIf="!isCurrentSortField('relevance')"></i>
                  <i class="fa-solid fa-sort-up" *ngIf="isCurrentSortField('relevance') && sortDirection === 'asc'"></i>
                  <i class="fa-solid fa-sort-down" *ngIf="isCurrentSortField('relevance') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th class="col-departments sortable-header" (click)="onSortClick('law_tags')">
                標籤
                <span [class]="getSortIndicatorClass('law_tags')">
                  <i class="fa-solid fa-sort" *ngIf="!isCurrentSortField('law_tags')"></i>
                  <i class="fa-solid fa-sort-up" *ngIf="isCurrentSortField('law_tags') && sortDirection === 'asc'"></i>
                  <i class="fa-solid fa-sort-down" *ngIf="isCurrentSortField('law_tags') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th style="width: 120px;" class="col-date sortable-header" (click)="onSortClick('law_modified_date')">
                修訂日期
                <span [class]="getSortIndicatorClass('law_modified_date')">
                  <i class="fa-solid fa-sort" *ngIf="!isCurrentSortField('law_modified_date')"></i>
                  <i class="fa-solid fa-sort-up" *ngIf="isCurrentSortField('law_modified_date') && sortDirection === 'asc'"></i>
                  <i class="fa-solid fa-sort-down" *ngIf="isCurrentSortField('law_modified_date') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th style="width: 120px;" class="col-change-date" >異動掃描</th>
            </tr>
          </thead>
          <tbody>
            <!-- 修改的可編輯行 -->
            <tr *ngIf="inlineEditing" class="editing-row">
              <td style="text-align:center;">
                <!-- 將保存和取消按鈕移到最前面的checkbox位置 -->
                <button class="action-btn save-btn" (click)="saveInlineLaw()" title="儲存">
                  <i class="fa-solid fa-save"></i>
                </button>
                <button class="action-btn cancel-btn" (click)="cancelInlineEdit()" title="取消">
                  <i class="fa-solid fa-times"></i>
                </button>
              </td>
              <td>
                <input type="text" [(ngModel)]="newInlineLaw.type" placeholder="請輸入分類">
              </td>
              <td>
                <select [(ngModel)]="newInlineLaw.law_hierarchy">
                  <option value="命令">命令</option>
                  <option value="法律">法律</option>
                  <option value="行政規則">行政規則</option>
                  <option value="其他">其他</option>
                </select>
              </td>
              <td>
                <input type="text" [(ngModel)]="newInlineLaw.law_name" placeholder="請輸入法規名稱">
              </td>
              <td>
                <input type="text" [(ngModel)]="newInlineLaw.law_url" placeholder="請輸入法規網址">
              </td>
              <td>
                <!-- 添加获取法条内容按钮，只在URL不为空时显示 -->
                <button *ngIf="newInlineLaw.law_url" class="get-content-btn" (click)="fetchInlineLawContent()"
                  [disabled]="newInlineLaw.isLoading" title="自動獲取法條內容">

                  <!-- 载入中状态 -->
                  <i class="fa-solid fa-spinner fa-spin" *ngIf="newInlineLaw.isLoading"></i>

                  <!-- 载入失败状态 -->
                  <i class="fa-solid fa-sync" *ngIf="newInlineLaw.loadFailed && !newInlineLaw.isLoading"></i>

                  <!-- 默认状态 -->
                  <i class="fa-solid fa-download" *ngIf="!newInlineLaw.isLoading && !newInlineLaw.loadFailed"></i>
                </button>

                <!-- 显示已载入的条数 -->
                <span *ngIf="newInlineLaw.articleCount > 0">
                  {{ newInlineLaw.articleCount }}
                </span>
              </td>
              <td>
                <!-- 法規代碼欄位 -->
                <input type="text" [(ngModel)]="newInlineLaw.law_index" placeholder="請輸入法規代碼">
              </td>
              <td>
                <!-- 相關性欄位 -->
                <div class="relevance-buttons">
                  <button class="relevance-btn" [class.active]="newInlineLaw.relevance === '相關'"
                    (click)="newInlineLaw.relevance = '相關'" title="相關">
                    O
                  </button>
                  <button class="relevance-btn" [class.active]="newInlineLaw.relevance === '無關'"
                    (click)="newInlineLaw.relevance = '無關'" title="無關">
                    X
                  </button>
                  <button class="relevance-btn" [class.active]="newInlineLaw.relevance === '參考'"
                    (click)="newInlineLaw.relevance = '參考'" title="參考">
                    -
                  </button>
                </div>
              </td>
              <td>
                <!-- 相關標籤欄位 -->
                <app-form-tags
                  [options]="topicTags"
                  [(ngModel)]="newInlineLaw.law_tags"
                  [placeholder]="'選擇或輸入標籤...'"
                  [label]="''"
                  [id]="'inline-tags-input'"
                  [name]="'inline-tags-input'"
                  (ngModelChange)="onInlineLawTagsChange($event)">
                </app-form-tags>
              </td>
              <td>
                <!-- 修訂日期欄位 -->
                <input type="date" [(ngModel)]="newInlineLaw.law_modified_date">
              </td>
              <td *ngIf="isCheckingChanges"></td>
            </tr>

            <!-- 現有的法規列表 -->
            <tr *ngFor="let law of filteredLaws" [class.modified-row]="isLawModified(law.law_id)">
              <td style="text-align:center;"><input type="checkbox" [(ngModel)]="law.selected"></td>
              <td>{{ law.type }}</td>
              <td>
                <!-- 非編輯模式：顯示可點擊的層級 -->
                <span *ngIf="!law.isEditingHierarchy" (click)="editHierarchy(law)">
                  {{ law.law_hierarchy || '未設定' }}
                </span>

                <!-- 編輯模式：顯示文本框 -->
                <input *ngIf="law.isEditingHierarchy" type="text" [(ngModel)]="law.law_hierarchy"
                  (blur)="saveHierarchy(law)" (keydown.enter)="saveHierarchy(law)" id="hierarchyInput-{{law.law_id}}"
                  class="hierarchy-input" />
              </td>



              <td>
                <!-- 當 law.law_url 有值時顯示超連結，否則顯示純文字 -->
                <a *ngIf="!law.isEditingSource && law.law_url" [href]="law.law_url" target="_blank"
                  class="law-url-link">
                  {{ law.law_name }}
                </a>
                <!-- 當 law.law_url 為空時只顯示純文字 -->
                <span *ngIf="!law.isEditingSource && !law.law_url">
                  {{ law.law_name }}
                </span>
              </td>
              <td>
                <!-- 非編輯模式：顯示可點擊的法規來源 -->
                <span *ngIf="!law.isEditingSource" (click)="editSource(law)">
                  {{ getlawsourcename(law.law_url) || '未設定' }}
                </span>


                <!-- 編輯模式：顯示輸入框 -->
                <input *ngIf="law.isEditingSource" type="text" [(ngModel)]="law.law_url" (blur)="saveSource(law)"
                  (keydown.enter)="saveSource(law)" id="sourceInput-{{law.law_id}}" />
              </td>
              <td>
                <!-- 法條數量或獲取按鈕 -->
                <button class="get-content-btn" (click)="fetchLawContent(law)"
                  *ngIf="(!law.articleCount || law.articleCount === 0) && !law.loadFailed" [disabled]="law.isLoading"
                  title="自動獲取法條內容">

                  <!-- 載入中狀態 -->
                  <i class="fa-solid fa-spinner fa-spin" *ngIf="law.isLoading"></i>

                  <!-- 默認狀態 -->
                  <i class="fa-solid fa-download" *ngIf="!law.isLoading"></i>
                </button>

                <!-- 載入失敗狀態 - 提供重試和檢視選項 -->
                <div class="error-actions" *ngIf="law.loadFailed && !law.isLoading">
                  <!-- 重試按鈕 -->
                  <button class="get-content-btn error-retry-btn" (click)="fetchLawContent(law)" title="重新嘗試獲取法條">
                    <i class="fa-solid fa-sync"></i>
                  </button>

                  <!-- 查看詳情連結 -->
                  <a class="canlink error-link" (click)="openArticlePopup(law)" title="查看詳細訊息或在彈出視窗中編輯">
                    <span class="error-text">編輯</span>
                  </a>
                </div>
                <!-- 顯示已載入的條數 -->
                <a class="canlink" (click)="openArticlePopup(law)" *ngIf="law.articleCount > 0 && !law.loadFailed">
                  {{ law.articleCount }}
                </a>
              </td>
              <td class="code-cell" style="text-align:center;">
                <span *ngIf="!law.isEditingCode" (click)="editCode(law)">
                  {{ law.law_index || '未設定' }}
                </span>
                <input *ngIf="law.isEditingCode" [(ngModel)]="law.law_index" (blur)="saveCode(law)" />
              </td>
              <td style="text-align:center;">
                <div class="relevance-buttons">
                  <button class="relevance-btn" [class.active]="law?.results?.related == 'V'"
                    (click)="setRelevance(law, 'related')" title="相關">
                    O
                  </button>
                  <button class="relevance-btn" [class.active]="law?.results?.unrelated == 'V'"
                    (click)="setRelevance(law, 'unrelated')" title="無關">
                    X
                  </button>
                  <button class="relevance-btn" [class.active]="law?.results?.reference == 'V'"
                    (click)="setRelevance(law, 'reference')" title="參考">
                    -
                  </button>
                </div>
              </td>

              <!-- 修改標籤顯示和輸入部分 -->
              <td class="departments-cell">
                <!-- 顯示已選擇的標籤標籤 (改用 law_tags) -->
                <div class="selected-tags inline" *ngIf="!law.showDeptInput">
                  <span class="department-tag" *ngFor="let dept of ensureArray(law.law_tags); let i = index">
                    {{ dept }}
                    <button type="button" class="remove-tag"
                      (click)="removeDepartmentFromLaw(law, i, $event)">×</button>
                  </span>
                  <!-- 添加標籤按鈕 (保持不變) -->
                  <button type="button" class="add-dept-btn" (click)="showDeptInputForLaw(law, $event)">+</button>
                </div>

                <!-- 使用 FormTagsComponent 替代原有的標籤輸入 -->
                <div *ngIf="law.showDeptInput" class="tags-input-wrapper">
                  <div class="tags-input-header">
                    <app-form-tags
                      [options]="topicTags"
                      [(ngModel)]="law.law_tags"
                      [placeholder]="'選擇或輸入標籤...'"
                      [label]="''"
                      [id]="'law-tags-' + (law.law_id || law.id)"
                      [name]="'law-tags-' + (law.law_id || law.id)"
                      (ngModelChange)="onLawTagsChange(law, $event)">
                    </app-form-tags>
                    <button type="button" class="close-tags-input-btn" (click)="hideDeptInputForLaw(law)" title="完成編輯">
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                </div>
              </td>
              <td style="text-align:center;">{{ law.law_modified_date }}</td>
              <td style="text-align:center;" (click)="ScanLawContent(law)" class="scan-date-cell">
                <div class="scan-date-content">
                  <!-- 載入中動畫 -->
                  <div *ngIf="law.isLoading" class="scan-result loading">
                    <i class="fa-solid fa-spinner fa-spin"></i>
                  </div>

                  <!-- 非載入中狀態 -->
                  <ng-container *ngIf="!law.isLoading">
                    <!-- 如果 ScanResult > law_modified_date：顯示「有新版本」按鈕 -->
                    <button *ngIf="law.ScanResult && isDateNewer(law.ScanResult, law.law_modified_date)"
                            class="scan-result new-version "
                            (click)="regulationUpdate(law); $event.stopPropagation()">
                      <i class="fa-solid fa-circle-exclamation"></i> 有新版本 {{ law.ScanResult }}
                    </button>

                    <!-- 如果 ScanResult = law_modified_date：顯示「√」符號 -->
                    <div *ngIf="law.ScanResult && law.ScanResult === law.law_modified_date" class="scan-result same-version">
                      <i class="fa-solid fa-check"></i> 不須更新 {{ law.ScanResult }}
                    </div>

                    <!-- 如果 ScanResult < law_modified_date：顯示「?」符號變成按鈕 -->
                    <button *ngIf="law.ScanResult && !isDateNewer(law.ScanResult, law.law_modified_date) && law.ScanResult !== law.law_modified_date"
                            class="scan-result old-version "
                            (click)="regulationUpdate(law); $event.stopPropagation()">
                      <i class="fa-solid fa-question"></i> 版本異常 {{ law.ScanResult }}
                    </button>
                  </ng-container>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  </div>

  <!-- 全螢幕彈出視窗 -->
  <!-- 法條內容預覽的視窗 -->
  <div class="popup fullscreen" *ngIf="isPopupVisible">
    <div class="popup-content">
      <!-- 關閉按鈕 -->
      <button class="close-btn" (click)="closePopup()">關閉</button>

      <!-- 法規相關資訊 -->
    <div class="law-info law-info-flex">
<div>
  <!-- 法規名稱 -->
  <h2 *ngIf="!isArticleEditMode">
    <a style="color: black;" [href]="selectedLaw?.law_url" target="_blank">
      {{ selectedLaw?.law_name || '未設定' }}
    </a>
  </h2>
  <div *ngIf="isArticleEditMode" class="edit-field">
    <label>法規名稱：</label>
    <input
      [(ngModel)]="selectedLaw.law_name"
      class="law-edit-input"
      [ngClass]="{'edited': isLawFieldTouched.law_name}"
      (ngModelChange)="onLawFieldTouched('law_name')" />
  </div>

  <!-- 發布日期 -->
  <p *ngIf="!isArticleEditMode"><strong>發布日期:</strong>{{ selectedLaw?.law_publish_date }}</p>
  <div *ngIf="isArticleEditMode" class="edit-field">
    <label>發布日期：</label>
    <input
      type="date"
      [(ngModel)]="selectedLaw.law_publish_date"
      class="law-edit-input"
      [ngClass]="{'edited': isLawFieldTouched.law_publish_date}"
      (ngModelChange)="onLawFieldTouched('law_publish_date')" />
  </div>

  <!-- 修改日期 -->
  <p *ngIf="!isArticleEditMode"><strong>修改日期:</strong> {{ selectedLaw?.law_modified_date }}</p>
  <div *ngIf="isArticleEditMode" class="edit-field">
    <label>修改日期：</label>
    <input
      type="date"
      [(ngModel)]="selectedLaw.law_modified_date"
      class="law-edit-input"
      [ngClass]="{'edited': isLawFieldTouched.law_modified_date}"
      (ngModelChange)="onLawFieldTouched('law_modified_date')" />
  </div>

  <!-- 分類 -->
  <p *ngIf="!isArticleEditMode"><strong>分類:</strong> {{ selectedLaw?.type }}</p>
  <div *ngIf="isArticleEditMode" class="edit-field">
    <label>分類：</label>
    <input
      [(ngModel)]="selectedLaw.type"
      class="law-edit-input"
      [ngClass]="{'edited': isLawFieldTouched.type}"
      (ngModelChange)="onLawFieldTouched('type')" />
  </div>

  <!-- 層級 -->
  <p *ngIf="!isArticleEditMode"><strong>層級:</strong> {{ selectedLaw?.law_hierarchy }}</p>
  <div *ngIf="isArticleEditMode" class="edit-field">
    <label>層級：</label>
    <input
      [(ngModel)]="selectedLaw.law_hierarchy"
      class="law-edit-input"
      [ngClass]="{'edited': isLawFieldTouched.law_hierarchy}"
      (ngModelChange)="onLawFieldTouched('law_hierarchy')" />
  </div>

  <!-- URL -->
  <div *ngIf="!isArticleEditMode"><strong>Url:</strong>
    <a *ngIf="selectedLaw?.law_url" [href]="selectedLaw.law_url" target="_blank" style="font-size:13px;">
      {{ selectedLaw.law_url }}
    </a>
  </div>
  <div *ngIf="isArticleEditMode" class="edit-field">
    <label>法規網址：</label>
    <input
      [(ngModel)]="selectedLaw.law_url"
      class="law-edit-input"
      [ngClass]="{'edited': isLawFieldTouched.law_url}"
      (ngModelChange)="onLawFieldTouched('law_url')" />
  </div>
</div>
  <div class="law-header-actions">
    <button class="edit-articles-btn" (click)="toggleArticleEditMode()"
      title="{{ isArticleEditMode ? '返回檢視模式' : '進入編輯模式' }}">
      <i class="fa-solid" [ngClass]="isArticleEditMode ? 'fa-eye' : 'fa-edit'"></i>
      {{ isArticleEditMode ? '返回檢視模式' : '進入編輯模式' }}
    </button>
  </div>
</div>

      <!-- 法條內容頂部按鈕列 -->
      <div class="article-header">
        <span style="font-size: 24px;">法條內容 </span>

        <!-- 只在編輯模式下顯示的功能按鈕 -->
        <div class="article-actions" *ngIf="isArticleEditMode">

          <button class="upload-file-btn" (click)="openPdfUploadDialog()" title="透過檔案上傳">
            <i class="fa-solid fa-file-upload"></i> 解析檔案
          </button>
          <button class="parse-text-btn" (click)="openTextParseDialog()" title="透過文字解析">
            <i class="fa-solid fa-font"></i> 解析文字
          </button>
          <button class="clear-articles-btn" *ngIf="selectedLawArticles.length > 0" (click)="confirmRemoveAllArticles()"
            title="清除所有法條">
            <i class="fa-solid fa-trash-alt"></i> 清除所有法條
          </button>
          <button class="save-articles-btn" *ngIf="isFormDataChanged" (click)="saveArticleChanges()" title="儲存變更">
            <i class="fa-solid fa-save"></i> 儲存變更
          </button>
        </div>
      </div>

      <!-- 法條內容顯示區域 -->
      <div class="article-content-area">
        <!-- 檢視模式 -->
        <div *ngIf="!isArticleEditMode">
          <div *ngIf="selectedLawArticles.length > 0; else noArticles">
            <div *ngFor="let article of selectedLawArticles" class="article-item">
              <p><strong>{{ article.article_no }}</strong></p>
              <p>{{ formatArticleContent(article.article_content) }}</p>
              <hr />
            </div>
          </div>
          <ng-template #noArticles>
            <p>無法條內容</p>
          </ng-template>
        </div>

        <!-- 編輯模式 -->
        <div *ngIf="isArticleEditMode" class="article-edit-area">

          <div class="edit-mode-toolbar">
            <div class="toolbar-left">
              <button class="add-article-btn" (click)="addNewArticle()">
                <i class="fa-solid fa-plus"></i> 新增法條
              </button>
              <button class="add-chapter-btn" (click)="addNewChapter()">
                <i class="fa-solid fa-folder-plus"></i> 新增章節
              </button>
              <span class="article-count-info">
                章節：{{ chapterCount }}
                法條：{{ articleCount }}
              </span>
            </div>
            <div class="toolbar-right">

              <button class="toggle-btn" [class.active]="!isJsonEditMode" (click)="toggleEditMode(false)"
                title="使用表單編輯模式">
                <i class="fa-solid fa-list"></i> 表單模式
              </button>
              <button class="toggle-btn" [class.active]="isJsonEditMode" (click)="toggleEditMode(true)"
                title="使用JSON編輯模式">
                <i class="fa-solid fa-code"></i> JSON模式
              </button>
            </div>
          </div>




          <!-- JSON 編輯模式 -->
          <div *ngIf="isJsonEditMode" class="json-edit-container">
            <textarea class="article-json-editor" [(ngModel)]="articlesJsonText" (input)="onArticlesJsonChanged()"
              rows="20" placeholder="法條內容 JSON 格式">
          </textarea>
            <div class="json-validation-message" *ngIf="jsonError">
              <i class="fa-solid fa-exclamation-triangle"></i>
              JSON 格式錯誤：{{ jsonError }}
            </div>
          </div>

          <!-- 表單編輯模式 -->
          <div *ngIf="!isJsonEditMode" class="form-edit-container">
            <!-- <div class="form-edit-footer">
              <button class="apply-changes-btn" (click)="applyArticleChanges()" [disabled]="!isFormDataChanged">
                <i class="fa-solid fa-check"></i> 套用變更
              </button>
            </div> -->

            <!-- 拖拉排序區塊 -->
            <div class="article-list" cdkDropList (cdkDropListDropped)="dropArticle($event)">
              <div *ngFor="let article of editableArticles; let i = index" class="article-edit-item" cdkDrag
                [ngClass]="{'edited': article.isNew || article.isEdited}">
                <div class="drag-handle" cdkDragHandle>
                  <i class="fa-solid fa-grip-vertical"></i>
                </div>
                <!-- 章節 -->
                <div *ngIf="article.article_type === 'C'" class="chapter-edit-form">
                  <input type="text" [(ngModel)]="article.article_content" placeholder="請輸入章節標題"
                    class="chapter-title-input" [ngClass]="{'edited': article.isNew || article.isEdited}" />
                </div>
                <!-- 法條 -->
                <div *ngIf="article.article_type === 'A'" class="article-edit-form">
                  <input type="text" [(ngModel)]="article.article_no" (ngModelChange)="onArticleChanged(i, 'no')"
                    placeholder="條號" class="article-no-input"
                    [ngClass]="{'edited': article.isNew || article.isNoEdited}" />

                  <textarea [(ngModel)]="article.article_content" rows="5"
                    (ngModelChange)="onArticleChanged(i, 'content')" placeholder="請輸入法條內容" class="article-content-input"
                    [ngClass]="{'edited': article.isNew || article.isContentEdited}"></textarea>
                </div>
                <!-- 右上角水平排列的按鈕 -->
                <div class="article-actions-group-horizontal">
                  <button class="icon-btn add-btn" (click)="addNewArticleBelow(i)" title="在下方插入新法條">
                    <i class="fa-solid fa-plus"></i>
                  </button>
                  <button class="icon-btn delete-btn" (click)="deleteArticle(i)" title="刪除此項">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
              <div *ngIf="editableArticles.length === 0" class="no-articles-message">
                <p>目前沒有法條內容，請使用上方按鈕新增法條或章節。</p>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- PDF 檔案上傳對話框 -->
  <div class="dialog-overlay" *ngIf="showPdfUploadDialog">
    <div class="dialog-container pdf-upload-dialog">
      <div class="dialog-header">
        <h3>透過 PDF 檔案解析法條</h3>
        <button class="close-btn" (click)="closePdfUploadDialog()">×</button>
      </div>

      <div class="dialog-body">

        <div class="file-upload-section">
          <div class="upload-container" [class.has-file]="pdfFile" (dragover)="onPdfDragOver($event)"
            (dragleave)="onPdfDragLeave($event)" (drop)="onPdfFileDrop($event)">

            <div class="upload-icon">
              <i class="fa-solid" [ngClass]="pdfFile ? 'fa-file-pdf' : 'fa-file-arrow-up'"></i>
            </div>

            <div class="upload-text">
              <span *ngIf="!pdfFile">將 PDF 檔案拖放至此，或</span>
              <span *ngIf="pdfFile">已選擇檔案: {{pdfFile.name}}</span>
              <label class="file-input-label" *ngIf="!pdfFile">
                點擊此處選擇檔案
                <input type="file" class="file-input" accept=".pdf" (change)="onPdfFileSelected($event)" #pdfFileInput>
              </label>
            </div>

            <div class="selected-file-actions" *ngIf="pdfFile">
              <button class="btn action-btn remove-btn" (click)="removePdfFile()">
                <i class="fa-solid fa-times"></i> 移除檔案
              </button>
            </div>
          </div>
        </div>

        <div class="pdf-upload-status" *ngIf="pdfUploadStatus">
          <div class="status-icon">
            <i class="fa-solid" [ngClass]="{'fa-spinner fa-spin': isPdfProcessing,
                         'fa-check-circle': pdfProcessSuccess,
                         'fa-exclamation-circle': !pdfProcessSuccess && pdfUploadStatus}">
            </i>
          </div>
          <div class="status-text" [class.error]="!pdfProcessSuccess && pdfUploadStatus">
            {{ pdfUploadStatus }}
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button class="btn cancel-btn" (click)="closePdfUploadDialog()" [disabled]="isPdfProcessing">取消</button>
        <button class="btn primary-btn" [disabled]="!pdfFile || isPdfProcessing" (click)="uploadPdfForParsing()">
          <i class="fa-solid" [ngClass]="isPdfProcessing ? 'fa-spinner fa-spin' : 'fa-upload'"></i>
          {{ isPdfProcessing ? '處理中...' : '上傳並解析' }}
        </button>
      </div>
    </div>
  </div>

  <!-- 文字解析對話框 -->
  <div class="dialog-overlay" *ngIf="showTextParseDialog">
    <div class="dialog-container text-parse-dialog">
      <div class="dialog-header">
        <h3>透過文字解析法條</h3>
        <button class="close-btn" (click)="closeTextParseDialog()">×</button>
      </div>

      <div class="dialog-body">


        <div class="form-section">
          <div class="form-group full-width">
            <label for="lawTextInput">請輸入要解析的法規文本:</label>
            <textarea id="lawTextInput" [(ngModel)]="lawTextInput" rows="15" placeholder="貼上要解析的法規全文..."
              class="law-text-input">
          </textarea>
          </div>
        </div>

        <div class="text-parse-status" *ngIf="textParseStatus">
          <div class="status-icon">
            <i class="fa-solid" [ngClass]="{'fa-spinner fa-spin': isTextProcessing,
                         'fa-check-circle': textProcessSuccess,
                         'fa-exclamation-circle': !textProcessSuccess && textParseStatus}">
            </i>
          </div>
          <div class="status-text" [class.error]="!textProcessSuccess && textParseStatus">
            {{ textParseStatus }}
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button class="btn cancel-btn" (click)="closeTextParseDialog()" [disabled]="isTextProcessing">取消</button>
        <button class="btn primary-btn"
          [disabled]="!lawTextInput || lawTextInput.trim().length < 10 || isTextProcessing" (click)="parseLawText()">
          <i class="fa-solid" [ngClass]="isTextProcessing ? 'fa-spinner fa-spin' : 'fa-code'"></i>
          {{ isTextProcessing ? '解析中...' : '解析文字' }}
        </button>
      </div>
    </div>
  </div>

  <!-- 全螢幕指派查核任務對話框 -->
  <div class="fullscreen-dialog" *ngIf="showTaskAssignmentDialog">
    <div class="dialog-content">
      <div class="dialog-header">
        <h2>指派查核任務</h2>
        <button class="close-btn" (click)="closeTaskAssignmentDialog()">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>

      <div class="dialog-body scrollable-content">
        <div class="form-group">
          <label for="taskTitle">查核主題</label>
          <input type="text" id="taskTitle" class="form-control" [(ngModel)]="taskTitle" placeholder="請輸入此次查核的主題"
            autofocus>
        </div>
        <!-- 日期同列 -->
        <div class="form-group date-row">
          <div class="date-group">
            <label for="taskStartDate">執行開始日期</label>
            <input type="date" id="taskStartDate" class="form-control" [(ngModel)]="taskStartDate">
          </div>
          <div class="date-group">
            <label for="taskEndDate">截止日期</label>
            <input type="date" id="taskEndDate" class="form-control" [(ngModel)]="taskEndDate">
          </div>
        </div>
        <div class="form-group">
          <label for="taskNote">備註</label>
          <textarea id="taskNote" class="form-control" [(ngModel)]="taskNote" rows="2" placeholder="請輸入備註"></textarea>
        </div>

        <!-- 鑑別群組多選下拉 -->
        <div class="form-group">
          <label>鑑別群組</label>
          <div #groupDropdown class="multiselect-dropdown group-multiselect-dropdown" (click)="$event.stopPropagation()">
            <div class="multiselect-selected" (click)="toggleGroupDropdown($event)">
              <span *ngIf="selectedGroups.length === 0">請選擇鑑別群組...</span>
              <span *ngIf="selectedGroups.length > 0">
                已選擇 {{ selectedGroups.length }} 個群組
              </span>
              <i class="fa-solid fa-chevron-down"></i>
            </div>
            <div class="multiselect-options" [class.show]="showGroupDropdown">
              <div class="multiselect-option" *ngFor="let group of missionGroups">
                <label class="checkbox-label group-option-label">
                  <input type="checkbox" [checked]="isGroupSelected(group)" (change)="toggleGroupSelection(group, $event)">
                  <span class="group-option-text">{{ group }}</span>
                </label>
              </div>
            </div>
          </div>
          <!-- 選取群組 summary -->
          <div class="selected-group-tags" *ngIf="selectedGroups.length > 0">
            <span class="group-tag" 
                  *ngFor="let group of selectedGroups"
                  [title]="getDepartmentMembersSummary(group)"
                  [class.loading]="loadingDepartmentMembers.has(group)">
              {{ group }}
              <span class="member-count" *ngIf="getDepartmentMembersCount(group) > 0">
                ({{ getDepartmentMembersCount(group) }}人)
              </span>
            </span>
          </div>
        </div>

        <!-- 法規數與標籤數同列 -->
        <div class="task-summary summary-row">
          <div class="summary-row-flex">
            <div class="summary-item">
              <i class="fa-solid fa-file-alt"></i>
              <span>共勾選 <strong>{{selectedLawCount}}</strong> 筆法規</span>
            </div>
            <div class="summary-item">
              <i class="fa-solid fa-building"></i>
              <span>共包含到 <strong>{{involvedDepartmentCount}}</strong> 個標籤</span>
            </div>
          </div>
           <div class="summary-note">
          <p>每一個鑑別群組都會收到對應的法規查核表，資料是彼此獨立的。</p>
          <p>共有 <strong class="email-count-tooltip" [title]="getAllEmailsSummary()">{{ getTotalMembersWithEmail() }}</strong> 人有信箱資料，將會收到信件通知。</p>
        </div>
        </div>
        <!-- 標籤 tags 無刪除功能且無圓角 -->
        <!-- <div class="department-tags-row">
          <div class="department-tags no-radius">
            <span class="department-tag no-radius" *ngFor="let dept of involvedDepartments">
              {{ dept }}
            </span>
          </div>
        </div> -->

      </div>

      <div class="dialog-footer">
        <button class="btn secondary-btn" (click)="closeTaskAssignmentDialog()">取消</button>
        <button class="btn primary-btn assign-btn"
                (click)="submitTaskAssignment()"
                [disabled]="isAssigningTask">
          <i class="fa-solid"
             [ngClass]="isAssigningTask ? 'fa-spinner fa-spin' : 'fa-clipboard-check'"></i>
          <span *ngIf="!isAssigningTask">確認指派</span>
          <span *ngIf="isAssigningTask">指派中...</span>
        </button>
      </div>
    </div>
  </div>

  <!-- 批次設定法規代碼對話框 -->
  <div class="dialog-overlay" *ngIf="showBatchCodeDialog">
    <div class="dialog-container">
      <div class="dialog-header">
        <h3>批次設定法規代碼</h3>
        <button class="close-btn" (click)="closeBatchCodeDialog()">×</button>
      </div>

      <div class="dialog-body">
        <p>您將為 <strong>{{ getSelectedLawsCount() }}</strong> 個已選擇的法規設定代碼。</p>

        <div class="form-group">
          <label for="batchCodePrefix">前綴</label>
          <input type="text" id="batchCodePrefix" [(ngModel)]="batchCodePrefix" placeholder="輸入法規代碼前綴 (例如：EL-)"
            class="form-control">
        </div>

        <div class="form-group">
          <label for="batchCodeStartNumber">起始編號</label>
          <input type="number" id="batchCodeStartNumber" [(ngModel)]="batchCodeStartNumber" placeholder="輸入起始編號 (例如：1)"
            class="form-control" min="1">
        </div>

        <div class="form-group">
          <label for="batchCodeDigits">編號位數</label>
          <input type="number" id="batchCodeDigits" [(ngModel)]="batchCodeDigits" placeholder="輸入編號位數 (例如：3 表示 001)"
            class="form-control" min="1" max="6">
        </div>

        <div class="preview-section">
          <h4>預覽</h4>
          <div class="code-preview">
            <p>第一個法規代碼將為：<strong>{{ previewFirstCode() }}</strong></p>
            <p>最後一個法規代碼將為：<strong>{{ previewLastCode() }}</strong></p>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button class="btn cancel-btn" (click)="closeBatchCodeDialog()">取消</button>
        <button class="btn primary-btn" (click)="applyBatchCodes()">套用</button>
      </div>
    </div>
  </div>

  <!-- 批次設定相關性對話框 -->
  <div class="dialog-overlay" *ngIf="showBatchRelevanceDialog">
    <div class="dialog-container">
      <div class="dialog-header">
        <h3>批次設定相關性</h3>
        <button class="close-btn" (click)="closeBatchRelevanceDialog()">×</button>
      </div>

      <div class="dialog-body">
        <p>您將為 <strong>{{ getSelectedLawsCount() }}</strong> 個已選擇的法規設定相關性。</p>

        <div class="relevance-selection">
          <h4>請選擇要設定的相關性：</h4>

          <div class="relevance-options">
            <div class="relevance-option" [class.selected]="batchRelevanceValue === '相關'"
              (click)="selectBatchRelevance('相關')">
              <div class="relevance-icon relevant">O</div>
              <div class="relevance-label">相關</div>
              <div class="relevance-desc">表示此法規與公司營運相關，需要遵循</div>
            </div>

            <div class="relevance-option" [class.selected]="batchRelevanceValue === '無關'"
              (click)="selectBatchRelevance('無關')">
              <div class="relevance-icon irrelevant">X</div>
              <div class="relevance-label">無關</div>
              <div class="relevance-desc">表示此法規與公司營運無關</div>
            </div>

            <div class="relevance-option" [class.selected]="batchRelevanceValue === '參考'"
              (click)="selectBatchRelevance('參考')">
              <div class="relevance-icon reference">-</div>
              <div class="relevance-label">參考</div>
              <div class="relevance-desc">表示此法規可做為營運參考，但非必要遵循</div>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button class="btn cancel-btn" (click)="closeBatchRelevanceDialog()">取消</button>
        <button class="btn primary-btn" [disabled]="!batchRelevanceValue" (click)="applyBatchRelevance()">套用</button>
      </div>
    </div>
  </div>

  <!-- 批次設定標籤對話框 -->
  <div class="dialog-overlay" *ngIf="showBatchDepartmentDialog">
    <div class="dialog-container batch-dept-dialog">
      <div class="dialog-header">
        <h3>批次設定標籤</h3>
        <button class="close-btn" (click)="closeBatchDepartmentDialog()">×</button>
      </div>

      <div class="dialog-body">
        <p>您將為 <strong>{{ getSelectedLawsCount() }}</strong> 個已選擇的法規設定標籤。</p>

        <div class="form-group">
          <label>更新模式：</label>
          <div class="radio-group">
            <label class="radio-option">
              <input type="radio" name="updateMode" [(ngModel)]="batchDeptUpdateMode" value="replace">
              <span class="radio-text">取代原有標籤</span>
              <span class="radio-desc">清空原有標籤設定，僅保留新選擇的標籤</span>
            </label>
            <label class="radio-option">
              <input type="radio" name="updateMode" [(ngModel)]="batchDeptUpdateMode" value="add">
              <span class="radio-text">追加到原有標籤</span>
              <span class="radio-desc">保留原有標籤設定，將新選擇的標籤加入</span>
            </label>
          </div>
        </div>

        <div class="department-selection">
          <h4>新增標籤：</h4>

          <!-- 自由輸入標籤 -->
          <div class="free-input-container">
            <div class="input-with-button">
              <input type="text" [(ngModel)]="newBatchDepartment" placeholder="輸入標籤名稱" class="dept-input"
                (keydown.enter)="addBatchDepartment()">
              <button class="btn add-btn" (click)="addBatchDepartment()">
                <i class="fa-solid fa-plus"></i>
              </button>
            </div>
          </div>

          <!-- 已選擇標籤標籤顯示 -->
          <div class="selected-summary" *ngIf="batchSelectedDepartments.length > 0">
            <h5>已新增 {{ batchSelectedDepartments.length }} 個標籤</h5>
            <div class="selected-dept-tags">
              <div class="selected-dept-tag" *ngFor="let dept of batchSelectedDepartments">
                {{ dept }}
                <button class="remove-dept-btn" (click)="removeBatchDepartment(dept, $event)">×</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button class="btn cancel-btn" (click)="closeBatchDepartmentDialog()">取消</button>
        <button class="btn primary-btn" [disabled]="batchSelectedDepartments.length === 0"
          (click)="applyBatchDepartments()">套用</button>
      </div>
    </div>
  </div>

  <!-- 範例法規選擇對話框 -->
  <div class="dialog-overlay" *ngIf="showSampleSelectionDialog">
    <div class="dialog-container sample-selection-dialog">
      <div class="dialog-header">
        <h3>從ISO範例資料庫新增法規</h3>
        <button class="close-btn" (click)="closeSampleSelectionDialog()">×</button>
      </div>

      <div class="dialog-body">
        <!-- 添加公司和主題選擇區域 -->


        <div class="sample-topics-section" [style.display]="isSampleSelectionExpanded ? 'block' : 'none'">
          <div class="topic-buttons">
            <button *ngFor="let topic of sampleTopics" class="topic-btn" [class.active]="selectedSampleTopic === topic"
              (click)="loadSampleLaws(topic)">
              {{ topic }}
            </button>
          </div>
        </div>

        <div class="company-topic-section" [style.display]="isSampleSelectionExpanded ? 'block' : 'none'">
          <div class="form-row">
            <!-- <div class="form-group">
            <label for="companySelect">選擇公司:</label>
            <div class="input-wrapper">
              <select
                id="companySelect"
                [(ngModel)]="selectedCompanyForSample"
                (change)="onSampleCompanyChange()"
                *ngIf="!isNewCompany">
                <option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</option>
                <option value="__new__">+ 新增其他公司</option>
              </select>
              <input
                type="text"
                *ngIf="isNewCompany"
                [(ngModel)]="newCompanyName"
                placeholder="請輸入新公司名稱"
                class="form-control">
              <button
                *ngIf="isNewCompany"
                class="btn small-btn"
                (click)="cancelNewCompany()">
                <i class="fa-solid fa-times"></i>
              </button>
            </div>
          </div> -->

            <div class="form-group">
              <label for="topicSelect">選擇主題:</label>
              <div class="input-wrapper">
                <select id="topicSelect" [(ngModel)]="selectedTopicForSample" (change)="onSampleTopicChange()"
                  *ngIf="!isNewTopic">
                  <option *ngFor="let topic of uniqueTopics" [value]="topic">{{ topic }}</option>
                  <option value="__new__">+ 新增其他主題</option>
                </select>
                <input type="text" *ngIf="isNewTopic" [(ngModel)]="newTopicName" placeholder="請輸入新主題名稱"
                  class="form-control">
                <button *ngIf="isNewTopic" class="btn small-btn" (click)="cancelNewTopic()">
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 修改 Type選擇區域，根據是否输入新公司/主题来显示或隐藏 -->
        <div class="type-selection-section" [style.display]="isSampleSelectionExpanded ? 'block' : 'none'">
          <h4>設定法規類型 (Type)</h4>
          <div class="type-option">
            <input type="radio" id="useOriginalType" name="typeOption" value="original" [(ngModel)]="typeSelectionMode">
            <label for="useOriginalType" style="margin-left: 10px;">使用範例資料庫中的分類</label>
          </div>

          <!-- 只在非新公司/主题的情况下显示 -->
          <div class="type-option" *ngIf="!isNewCompany && !isNewTopic">
            <input type="radio" id="useExistingType" name="typeOption" value="existing" [(ngModel)]="typeSelectionMode">
            <label for="useExistingType" style="margin-left: 10px;">加入既有分類中：</label>
            <select [disabled]="typeSelectionMode !== 'existing'" [(ngModel)]="selectedTargetType">
              <option *ngFor="let type of uniqueTypesWithCounts" [value]="type.type">{{ type.type }}</option>
            </select>
          </div>

          <div class="type-option">
            <input type="radio" id="createNewType" name="typeOption" value="new" [(ngModel)]="typeSelectionMode">
            <label for="createNewType" style="margin-left: 10px;">手動建立新分類：</label>
            <input type="text" [disabled]="typeSelectionMode !== 'new'" [(ngModel)]="newTypeName" placeholder="輸入新分類名稱"
              class="new-type-input">
          </div>
        </div>

        <!-- 其余部分不变 -->
        <div class="sample-laws-section" [class.expanded]="!isSampleSelectionExpanded">
          <div class="sample-laws-header">
            <h4>選擇要加入的法規 <small>（請勾選要新增的法規）</small></h4>
            <button class="btn small-btn" (click)="toggleSampleSelectionVisibility()"><i class="fa-solid"
                [ngClass]="isSampleSelectionExpanded ? 'fa-expand' : 'fa-compress'"></i> {{ isSampleSelectionExpanded ?
              '放大' : '復原' }}</button>
          </div>

          <!-- 法規名稱搜尋區域 -->
          <div class="sample-search-section" *ngIf="!isSampleLoading && sampleLaws.length > 0">
            <div class="search-input-group">
              <label for="sampleSearchInput">法規名稱搜尋：</label>
              <div class="input-with-button">
                <input
                  id="sampleSearchInput"
                  type="text"
                  [(ngModel)]="sampleSearchKeyword"
                  placeholder="請輸入法規名稱關鍵字..."
                  class="search-input"
                  (keyup.enter)="onSearchButtonClick()"
                />
                <button
                  type="button"
                  class="btn search-btn"
                  (click)="onSearchButtonClick()"
                  title="搜尋法規">
                  <i class="fa-solid fa-search"></i>
                </button>
                <button
                  type="button"
                  class="btn clear-btn"
                  (click)="clearSampleSearch()"
                  title="清除搜尋"
                  *ngIf="sampleSearchKeyword">
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>
            </div>
            <!-- {{sampleSearchKeyword}}
            <div class="search-result-info" *ngIf="sampleSearchKeyword">
              搜尋結果：{{ filteredSampleLaws.length }} / {{ sampleLaws.length }} 筆法規
            </div> -->
          </div>

          <div *ngIf="isSampleLoading" class="loading-spinner">
            <i class="fa-solid fa-spinner fa-spin"></i> 載入中...
          </div>


          <!-- <div><span *ngIf="sampleSearchKeyword">{{ filteredSampleLaws.length }} / </span>{{ sampleLaws.length }} 筆法規</div> -->
          <!-- 添加表格容器 -->
          <div class="table-container" *ngIf="!isSampleLoading && filteredSampleLaws.length > 0">
            <table class="sample-laws-table">
              <thead>
                <tr>
                  <th style="width: 40px;">
                    <input type="checkbox" (change)="toggleAllSampleLaws($event)">
                  </th>
                  <th style="width: 150px;">分類</th>
                  <th style="width: 300px;">法規名稱</th>
                  <th style="width: 80px;">位階</th>
                  <th>法規網址</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let law of filteredSampleLaws" [class.updated]="law.hasUpdated">
                  <td>
                    <input type="checkbox" [checked]="isSampleLawSelected(law.law_id || law.id)"
                      (change)="toggleSampleLawSelection(law.law_id || law.id)">
                  </td>
                  <td>{{ law.type || '' }}</td>
                  <td>{{ law.law_name }}</td>
                  <td>{{ law.law_hierarchy }}</td>
                  <td>{{ law.law_url}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="!isSampleLoading && sampleLaws.length > 0 && filteredSampleLaws.length === 0 && sampleSearchKeyword" class="no-search-results-message">
            找不到符合「{{ sampleSearchKeyword }}」的法規，請嘗試其他關鍵字。
          </div>

          <div *ngIf="!isSampleLoading && sampleLaws.length === 0" class="no-laws-message">
            目前沒有可用的法規資料，請選擇其他分類。
          </div>
        </div>


      </div>

      <div class="dialog-footer">
        <button class="btn cancel-btn" (click)="closeSampleSelectionDialog()">取消</button>
        <button class="btn primary-btn"
          [disabled]="selectedSampleLaws.size === 0 || !isValidSampleSelectionForm() || isAddingSampleLaws"
          (click)="addSelectedSampleLaws()">
          <i class="fa-solid" [ngClass]="isAddingSampleLaws ? 'fa-spinner fa-spin' : 'fa-plus'"></i>
          {{ isAddingSampleLaws ? '處理中...' : '新增已選法規 (' + selectedSampleLaws.size + ')' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Excel檔案匯入對話框 -->
  <div class="dialog-overlay" *ngIf="showExcelImportDialog">
    <div class="dialog-container excel-import-dialog">
      <div class="dialog-header">
        <h3>從Excel檔案匯入法規</h3>
        <button class="close-btn" (click)="closeExcelImportDialog()">×</button>
      </div>

      <div class="dialog-body">
        <div class="import-instructions">
          <h4>匯入說明</h4>
          <p>請上傳包含法規資料的Excel檔案(.xlsx)。</p>
        </div>

        <!-- 添加公司ID和主題欄位 -->
        <div class="form-section">
          <div class="form-row">
            <!-- <div class="form-group">
            <label for="importCompanyId" class="required-field">公司代碼:</label>
            <input
              type="text"
              id="importCompanyId"
              class="form-control"
              [(ngModel)]="importCompanyId"
              placeholder="請輸入公司代碼"
              required>
          </div> -->

            <div class="form-group">
              <label for="importTopic" class="required-field">主題:</label>
              <input type="text" id="importTopic" class="form-control" [(ngModel)]="importTopic" placeholder="請輸入主題"
                required>
            </div>
          </div>
        </div>

        <div class="file-upload-section">
          <div class="upload-container" [class.has-file]="excelFile" (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)">

            <div class="upload-icon">
              <i class="fa-solid" [ngClass]="excelFile ? 'fa-file-excel' : 'fa-file-arrow-up'"></i>
            </div>

            <div class="upload-text">
              <span *ngIf="!excelFile">將Excel檔案拖放至此，或</span>
              <span *ngIf="excelFile">已選擇檔案: {{excelFile.name}}</span>
              <label class="file-input-label" *ngIf="!excelFile">
                點擊此處選擇檔案
                <input type="file" class="file-input" accept=".xlsx" (change)="onFileSelected($event)" #fileInput>
              </label>
            </div>

            <div class="selected-file-actions" *ngIf="excelFile">
              <button class="btn action-btn remove-btn" (click)="removeSelectedFile()">
                <i class="fa-solid fa-times"></i> 移除檔案
              </button>
            </div>
          </div>
        </div>

      </div>

      <div class="dialog-footer">
        <div class="import-status" *ngIf="importStatus">
          <div class="status-text">{{importStatus}}</div>
        </div>

        <div class="button-group">
          <button class="btn cancel-btn" (click)="closeExcelImportDialog()" [disabled]="isImporting">取消</button>
          <button class="btn primary-btn"
            [disabled]="!excelFile || !importCompanyId || !importTopic || isImporting || hasValidationErrors"
            (click)="importExcelData()">
            <i class="fa-solid" [ngClass]="isImporting ? 'fa-spinner fa-spin' : 'fa-file-import'"></i>
            {{isImporting ? '轉換中...' : '進行轉換'}}
          </button>

          <button class="btn btn-success" *ngIf="excelconveterresult && excelconveterresult.length > 0"
            (click)="downloadResultsAsJson()" [disabled]="isImporting">
            <i class="fa-solid fa-download"></i> 下載轉換結果
          </button>

          <!-- 如果有轉換結果，顯示下載和儲存按鈕 -->
          <div  *ngIf="excelconveterresult && excelconveterresult.length > 0" class="d-flex gap-2">

            <button class="btn btn-success" (click)="saveExcelDataToDatabase()" [disabled]="isImporting">
              <i class="fa fa-database me-1"></i>儲存至資料庫
            </button>
          </div>
        </div>

      </div>

    </div>
  </div>

  <!-- 添加編輯主題名稱對話框 -->
<div class="dialog-overlay" *ngIf="showEditTopicDialog">
  <div class="dialog-container">
    <div class="dialog-header">
      <h3>編輯主題名稱</h3>
      <button class="close-btn" (click)="closeEditTopicDialog()">×</button>
    </div>

    <div class="dialog-body">
      <div class="form-group">
        <label>目前的主題名稱:</label>
        <div class="form-control" style="background:#f5f5f5;" readonly>
          {{ currentTopicName }}
        </div>
      </div>

      <div class="form-group">
        <label for="newTopicName">新的主題名稱:</label>
        <input type="text" id="newTopicName" [(ngModel)]="newTopicName" class="form-control" placeholder="請輸入新的主題名稱">
      </div>
    </div>

    <div class="dialog-footer">
      <button class="btn cancel-btn" (click)="closeEditTopicDialog()">取消</button>
      <button class="btn primary-btn"
              [disabled]="!currentTopicName || !newTopicName || isUpdatingTopic"
              (click)="updateTopicName()">
        <i class="fa-solid fa-spinner fa-spin" *ngIf="isUpdatingTopic"></i>
        <span *ngIf="!isUpdatingTopic">確認更新</span>
        <span *ngIf="isUpdatingTopic">處理中...</span>
      </button>
    </div>
  </div>
</div>

<!-- 添加刪除主題對話框 -->
<div class="dialog-overlay" *ngIf="showDeleteTopicDialog">
  <div class="dialog-container">
    <div class="dialog-header">
      <h3>刪除主題</h3>
      <button class="close-btn" (click)="closeDeleteTopicDialog()">×</button>
    </div>

    <div class="dialog-body">
      <div class="form-group">
        <label for="topicToDelete">請選擇要刪除的主題:</label>
        <div class="form-control" style="background:#f5f5f5;" readonly>
          {{ topicToDelete }}
        </div>
      </div>

      <div class="confirmation-message" *ngIf="topicToDelete">
        <p class="warning-text"><i class="fa-solid fa-exclamation-triangle"></i> 警告：刪除主題將移除與該主題相關的所有法規資料，包含合規性判別結果。此操作無法復原。</p>
        <div class="confirmation-input">
          <label>請輸入主題名稱「{{ topicToDelete }}」以確認刪除:</label>
          <input type="text" [(ngModel)]="confirmDeleteText" class="form-control">
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button class="btn cancel-btn" (click)="closeDeleteTopicDialog()">取消</button>
      <button class="btn danger-btn"
              [disabled]="!topicToDelete || confirmDeleteText !== topicToDelete || isDeletingTopic"
              (click)="deleteTopic()">
        <i class="fa-solid fa-spinner fa-spin" *ngIf="isDeletingTopic"></i>
        <span *ngIf="!isDeletingTopic">確認刪除</span>
        <span *ngIf="isDeletingTopic">處理中...</span>
      </button>
    </div>
  </div>
</div>

<!-- 法規更新與比較元件 -->
<app-law-update-and-compare
  *ngIf="showLawUpdateCompare"
  [selectedLaw]="currentLawForUpdate"
  (closePopup)="closeLawUpdateCompare()"
  (updateConfirmed)="onLawUpdateConfirmed($event)">
</app-law-update-and-compare>
